import React, {useState} from 'react';
import {DataGrid, QuickFilter, QuickFilterClear, QuickFilterControl, Toolbar} from "@mui/x-data-grid";
import {Checkbox, FormControlLabel, InputAdornment, Stack} from "@mui/material";
import TextField from "@mui/material/TextField";
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';

const common = {sortable: true, disableColumnMenu: false, headerClassName: 'grid-header'};
const colDefs = [
    {...common, width: 110, headerName: 'First Name', field: 'first_name'},
    {...common, width: 160, headerName: 'Last Name', field: 'last_name'},
    {...common, width: 100, headerName: 'Pos', field: 'pos', headerAlign: 'center', align: 'center'},
    {...common, width: 70, headerName: 'Team', field: 'team', headerAlign: 'center', align: 'center'}
];

const calcWidth = (cols) => {
    return cols.reduce((t, c) => t + c.width, 0) + 2;
};

const gridWidth = calcWidth(colDefs);

const determineRowClass = (params) => {
    return `${params.indexRelativeToCurrentPage % 2 === 1 ? 'table-row-odd' : 'table-row-even'}`
};

const CustomToolbar = () => {
    return (
        <Toolbar>
            <QuickFilter expanded>
                <QuickFilterControl render={({ref, ...other}) => (
                    <TextField {...other} sx={{width: gridWidth - 15}} inputRef={ref} aria-label="Search"
                               placeholder="Search..." size="small"
                               slotProps={{
                                   input: {
                                       startAdornment: (
                                           <InputAdornment position="start">
                                               <SearchIcon fontSize="small"/>
                                           </InputAdornment>),
                                       endAdornment: other.value ? (
                                           <InputAdornment position="end">
                                               <QuickFilterClear edge="end" size="small" aria-label="Clear search"
                                                                 material={{sx: {marginRight: -0.75}}}>
                                                   <CancelIcon fontSize="small"/>
                                               </QuickFilterClear>
                                           </InputAdornment>
                                       ) : null,
                                       ...other.slotProps?.input
                                   },
                                   ...other.slotProps
                               }}
                    />
                )}
                />
            </QuickFilter>
        </Toolbar>
    );
};

export const AvailablePlayerGrid = ({rows}) => {
    const [filterModel, setFilterModel] = useState({
        items: [{
            field: 'pos',
            operator: 'isAnyOf',
            value: ['All', 'QB', 'WR', 'RB', 'TE', 'K']
        }]
    });

    const updateFilterModel = (event, val) => {
        const newFilterModel = {...filterModel};
        const values = newFilterModel.items[0].value;
        if (event.target.checked) {
            values.push(val);
            if (values.length === 5 && !values.includes('All')) values.push('All');
        } else {
            values.splice(values.indexOf(val), 1);
            if (values.includes('All')) values.splice(values.indexOf('All'), 1);
        }
        setFilterModel(newFilterModel);
    };

    const handleAllFilter = (event) => {
        const newFilterModel = {...filterModel};
        if (event.target.checked) {
            newFilterModel.items[0].value = ['All', 'QB', 'WR', 'RB', 'TE', 'K'];
        } else {
            newFilterModel.items[0].value = [];
        }
        setFilterModel(newFilterModel);
    };

    const filtersInclude = (pos) => {
        return filterModel.items && filterModel.items.length > 0 && filterModel.items[0].value && filterModel.items[0].value.includes(pos);
    };

    return (
        <div style={{width: gridWidth, marginTop: 10, marginBottom: 50}}>
            <Stack direction="row" spacing={1} style={{marginLeft: 10}}>
                <FormControlLabel label="All" control={<Checkbox checked={filtersInclude('All')} onChange={handleAllFilter}/>}/>
                <FormControlLabel label="QB" control={<Checkbox checked={filtersInclude('QB')} onChange={e => updateFilterModel(e, 'QB')}/>}/>
                <FormControlLabel label="WR" control={<Checkbox checked={filtersInclude('WR')} onChange={e => updateFilterModel(e, 'WR')}/>}/>
                <FormControlLabel label="RB" control={<Checkbox checked={filtersInclude('RB')} onChange={e => updateFilterModel(e, 'RB')}/>}/>
                <FormControlLabel label="TE" control={<Checkbox checked={filtersInclude('TE')} onChange={e => updateFilterModel(e, 'TE')}/>}/>
                <FormControlLabel label="K" control={<Checkbox checked={filtersInclude('K')} onChange={e => updateFilterModel(e, 'K')}/>}/>
            </Stack>
            <DataGrid columns={colDefs} rows={rows} pageSizeOptions={[25]}
                      initialState={{pagination: {paginationModel: {pageSize: 25, page: 0}}}}
                      filterModel={filterModel} onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
                      columnHeaderHeight={30} rowHeight={23}
                      getRowClassName={(params) => (determineRowClass(params))}
                      showToolbar disableColumnSelector disableDensitySelector
                      disableRowSelectionOnClick disableMultipleRowSelection disableColumnResize
                      slots={{toolbar: CustomToolbar}}/>
        </div>
    );
}
